// src/pages/SubDealer/ViewSubDealer.jsx
import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import subDealerService from '../../services/subDealer.service';
import Toast from '../../components/Toast/Toast';
import '../../styles/AddPages.css';

const ViewSubDealer = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [subDealer, setSubDealer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState(null);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await subDealerService.getSubDealerById(id);
        if (res.success) {
          setSubDealer(res.data?.data || res.data);
        }
      } catch (e) {
        setToast({ message: 'Failed to fetch sub-dealer', type: 'error' });
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [id]);

  const formatDate = (val) => {
    if (!val) return null;
    const d = new Date(val);
    return isNaN(d.getTime()) ? null : d.toLocaleDateString('en-IN');
  };

  const DetailRow = ({ label, value }) => (
    <div className="form-group">
      <label className="form-label" style={{ fontWeight: 600, color: '#555' }}>{label}</label>
      <div className="form-input" style={{
        background: '#f8f9fa', color: '#333', cursor: 'default',
        minHeight: 42, display: 'flex', alignItems: 'center',
      }}>
        {value || <span style={{ color: '#aaa' }}>—</span>}
      </div>
    </div>
  );

  if (loading) {
    return <div className="add-dealer-page"><p style={{ padding: 40, textAlign: 'center' }}>Loading...</p></div>;
  }
  if (!subDealer) {
    return (
      <div className="add-dealer-page">
        <p>Sub-dealer not found.</p>
        <button className="btn btn-secondary" onClick={() => navigate('/sub-dealer/view')}>Back</button>
      </div>
    );
  }

  return (
    <div className="add-dealer-page">
      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}

      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item"><a href="/dashboard/overview">Dashboard</a></li>
          <li className="breadcrumb-item"><a href="/sub-dealer/view">Sub-Dealers</a></li>
          <li className="breadcrumb-item active">View Sub-Dealer</li>
        </ol>
      </nav>

      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h4 className="page-title">Sub-Dealer Details</h4>
        <button className="btn btn-primary" onClick={() => navigate(`/sub-dealer/edit/${id}`)}>
          ✏️ Edit
        </button>
      </div>

      <div className="form-card">
        {subDealer.photo && (
          <div style={{ marginBottom: 20 }}>
            <img src={subDealer.photo} alt="Sub-Dealer"
              style={{ width: 100, height: 100, borderRadius: 8, objectFit: 'cover', border: '1px solid #e0e0e0' }} />
          </div>
        )}

        <div className="form-section">
          <div className="form-row">
            <DetailRow label="Shop Name"     value={subDealer.subDealerShopName} />
            <DetailRow label="Owner"         value={subDealer.ownerName} />
            <DetailRow label="Date of Birth" value={formatDate(subDealer.dateOfBirth)} />
          </div>
        </div>

        {/* Parent dealer info */}
        <div className="form-section">
          <div className="form-row">
            <DetailRow label="Parent Dealer"     value={subDealer.dealer?.dealerShopName} />
            <DetailRow label="Parent HQ"         value={subDealer.dealer?.headquarter?.name} />
            <DetailRow label="Parent Region"     value={subDealer.dealer?.region?.name} />
          </div>
        </div>

        <div className="form-section">
          <div className="form-row">
            <DetailRow label="GST Number"   value={subDealer.gstNumber} />
            <DetailRow label="PAN Number"   value={subDealer.panNumber} />
            <DetailRow label="Aadhar"       value={subDealer.aadharCardNumber} />
          </div>
        </div>

        <div className="form-section">
          <div className="form-row">
            <div className="form-group form-group-full">
              <label className="form-label" style={{ fontWeight: 600, color: '#555' }}>Address</label>
              <div className="form-input" style={{
                background: '#f8f9fa', color: '#333', cursor: 'default',
                minHeight: 60, alignItems: 'flex-start', padding: '10px 12px',
              }}>
                {subDealer.address || <span style={{ color: '#aaa' }}>—</span>}
              </div>
            </div>
          </div>
          <div className="form-row">
            <DetailRow label="State"    value={subDealer.state} />
            <DetailRow label="District" value={subDealer.district} />
            <DetailRow label="Tahsil"   value={subDealer.tahsil} />
          </div>
        </div>

        <div className="form-section">
          <div className="form-row">
            <DetailRow label="Mobile" value={subDealer.mobile} />
            <DetailRow label="Email"  value={subDealer.email} />
          </div>
        </div>

        <div className="form-section">
          <div className="form-row">
            <DetailRow label="Latitude"  value={subDealer.latitude} />
            <DetailRow label="Longitude" value={subDealer.longitude} />
            <DetailRow label="Remark"    value={subDealer.remark} />
          </div>
        </div>

        {subDealer.latitude && subDealer.longitude && (
          <div style={{ marginTop: 16 }}>
            <label className="form-label" style={{ fontWeight: 600, color: '#555' }}>Location Map</label>
            <div style={{ borderRadius: 8, overflow: 'hidden', border: '1px solid #e0e0e0' }}>
              <iframe
                title="Sub-Dealer Location"
                width="100%" height="220" style={{ border: 'none', display: 'block' }}
                src={`https://maps.google.com/maps?q=${subDealer.latitude},${subDealer.longitude}&z=14&output=embed`}
              />
            </div>
          </div>
        )}

        <div className="form-actions">
          <button className="btn btn-secondary" onClick={() => navigate('/sub-dealer/view')}>← Back</button>
          <button className="btn btn-primary" onClick={() => navigate(`/sub-dealer/edit/${id}`)}>✏️ Edit</button>
        </div>
      </div>
    </div>
  );
};

export default ViewSubDealer;